import React from 'react';
import { Language } from '@/domainLogic/index.ts';
import styled from 'styled-components';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import Stars from '@/app/common/components/Stars';
import { LabelText } from '@/app/components/search/components/Filters/HorizontalFilters/Pill/styled.ts';
import FilterContainer from '../../verticalFilters/FilterContainer';

type LabelProps = {
  label: string;
  control: string | undefined;
  selected: boolean;
};

const SpacedStars = styled(Stars)`
  margin-left: 4px;
`;

const Label = ({ label, control, selected }: LabelProps) => {
  const {
    localization: { lang },
  } = usePageWrapperData();
  const isGermanStarsControl = selected && lang === Language.DE && control === FilterContainer.StarsContainer;

  return (
    <>
      {label && (
        <LabelText variant="BodySmall" as="span">
          {label}
        </LabelText>
      )}
      {isGermanStarsControl && <SpacedStars stars={1} />}
    </>
  );
};

export default Label;
